export const replaceProductHyphensWithSlashes = (text: string) => text.replace(/( - )/g, '  /  ');
